<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-brush"></i>
              材料颜色管理
            </h1>
            <p class="page-subtitle">管理材料可选颜色配置，设置颜色名称、颜色值和单价</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加颜色" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()"></el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item>
                <el-input v-model="searchCondition.color_name" placeholder="请输入颜色名称" clearable prefix-icon="el-icon-brush">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column slot="first-column" width="60" label="序号" align="center">
              <template slot-scope="scope">
                <span class="sequence-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>

            <el-table-column label="颜色预览" width="100" align="center">
              <template slot-scope="scope">
                <div class="color-preview">
                  <div 
                    class="color-circle" 
                    :style="'background:' + scope.row.color_value"
                    :title="scope.row.color_value">
                  </div>
                  <span class="color-code">{{scope.row.color_value}}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="颜色信息" min-width="200">
              <template slot-scope="scope">
                <div class="color-info">
                  <div class="info-row">
                    <i class="el-icon-brush"></i>
                    <span class="info-label">颜色名称：</span>
                    <span class="info-value">{{scope.row.color_name}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-coin"></i>
                    <span class="info-label">单价：</span>
                    <el-tag size="mini" type="success">¥{{scope.row.material_base_price}}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="120" align="center">
              <template slot-scope="scope">
                <div class="status-switch">
                  <span class="switch-label">启用状态</span>
                  <el-switch 
                    v-model="scope.row.color_status" 
                    :active-value="'1'" 
                    :inactive-value="'0'" 
                    active-color="#67c23a" 
                    inactive-color="#f56c6c"
                    @change="changeStatus(scope.row)">
                  </el-switch>
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="buttonType=='icon'" width="100" label="操作" align="center">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑颜色" placement="top">
                    <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="editButton(scope.row.id)"></el-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="颜色名称" prop="color_name">
                <el-input v-model="formData.color_name" prefix-icon="el-icon-brush"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="颜色状态" prop="color_status">
                <el-switch v-model="formData.color_status" :active-value="'1'" :inactive-value="'0'"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="颜色单价" prop="material_base_price">
                <el-input v-model="formData.material_base_price" prefix-icon="el-icon-coin">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="颜色选择" prop="color_value">
                <div class="color-picker-section">
                  <el-color-picker v-model="formData.color_value"></el-color-picker>
                  <span class="color-info">当前颜色：{{formData.color_value || '未选择'}}</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <I18nTranslatePanel entity-type="material_color" :entity-id="formData.id || ''" />
        </el-form>     
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader,
    I18nTranslatePanel
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 10,
        color_name:'',
        query: "",
        params: [],
      },
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        page_size: 20,
        current_page: 1,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      // 表单验证
      rules: {
        color_name: [{required: true,message:'输入颜色名称', trigger: 'blur' }],
        color_value: [{required: true,message:'输入颜色描述', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: []
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 搜索
    searchButton() {
      this.list()
    },
    // 切换页码操作
    async switchPaging() {
      this.list()
    },
    // 响应颜色状态切换
    async changeStatus(row) {
      let res = await this.$api.post('/service/ola_app_material_color/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.list()
      }else{
        this.$message.error(res.message)
      }
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(ID：'+id+')'
      let res = await this.$api.post('/service/ola_app_material_color/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_material_color/create'
      if(this.formData.id!=undefined && this.formData.id!=''){
        url = '/service/ola_app_material_color/update'
      }
      this.formData.material_id = this.$route.params.id
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.initFormData()
        this.list()
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.craft_status=='0'){
        row.craft_status='1'
      }else{
        row.craft_status='0'
      }
      let id = await this.$api.modifyMaterialColour(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.list()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.post('/service/ola_app_material_color/delete',{id:id})
      if (this.$apiSuccess(res)){
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.list()
        })
      } else {
        this.$message.error(res.message)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    // 初始化数据列表
    async list() {
      this.loadingStaus=true
      this.searchCondition.query= 'material_id=?'
      this.searchCondition.params = [this.$route.params.id]
      if (this.searchCondition.color_name != ''){
        this.searchCondition.query =this.searchCondition.query + ' and instr(color_name,?)>0'
        this.searchCondition.params.push(this.searchCondition.color_name)
      }
      Object.assign(this.searchCondition,this.pagingData)
      let res= await this.$api.post('/service/ola_app_material_color/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList = res.data.list
        this.pagingData.total = res.data.page.total
      }else{
        this.dataList = []
        this.pagingData.total = 0
        this.$message.error(res.message)
      }
      this.loadingStaus=false
    }
  },
  mounted() {
    this.list()
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
      font-size 24px
      font-weight 600
      display flex
      align-items center
      
      i
        margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 颜色预览样式
.color-preview
  display flex
  flex-direction column
  align-items center
  gap 8px
  
  .color-circle
    width 40px
    height 40px
    border-radius 50%
    border 3px solid #fff
    box-shadow 0 2px 8px rgba(0, 0, 0, 0.15)
    cursor pointer
    transition all 0.3s ease
    
    &:hover
      transform scale(1.1)
      box-shadow 0 4px 12px rgba(0, 0, 0, 0.25)
  
  .color-code
    font-size 10px
    color #909399
    font-family monospace
    text-transform uppercase

// 颜色信息样式
.color-info
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 60px
    
    .info-value
      color #303133
      font-weight 500

// 状态开关样式
.status-switch
  display flex
  flex-direction column
  align-items center
  gap 6px
  
  .switch-label
    font-size 11px
    color #909399

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 颜色选择器样式
.color-picker-section
  display flex
  align-items center
  gap 12px
  
  .color-info
    font-size 14px
    color #606266
    font-family monospace

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-select
  .el-input__inner
    border-radius 6px

/deep/ .el-tag
  border-radius 6px
  font-weight 500

/deep/ .el-switch
  .el-switch__core
    border-radius 10px

/deep/ .el-color-picker
  .el-color-picker__trigger
    border-radius 6px
    border 2px solid #dcdfe6
    transition all 0.3s ease
    
    &:hover
      border-color #409eff
</style>
